var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 4h-18c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h18c1.103 0 2-.897 2-2v-11c0-1.103-.897-2-2-2zm0 1l.159.032-9.159 7.328-9.159-7.328.159-.032h18zm1 12c0 .551-.449 1-1 1h-18c-.551 0-1-.449-1-1v-11c0-.11.03-.21.063-.309l9.625 7.7c.091.072.202.109.312.109s.221-.037.312-.109l9.625-7.7c.033.099.063.199.063.309v11z"}));
}

Email.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Email;

Email.default = Email;
